import { Auth } from 'aws-amplify';
import { configureAmplify } from './amplify';
import { logger } from '../baselineApis';

export async function getUserDetails() {
  try {
    configureAmplify();
    const session = await Auth.currentSession();
    return session?.idToken?.payload;
  } catch (error) {
    logger.error({ error, function: getUserDetails.name });
  }
}
